var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.SkinComponent, {
    tag: "component",
    on: {
      "submit": _vm.submit
    },
    model: {
      value: _vm.user,
      callback: function callback($$v) {
        _vm.user = $$v;
      },
      expression: "user"
    }
  });
}
var staticRenderFns = []

export { render, staticRenderFns }